let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}


/* Ruff Iron: restore Kiwi after Dawn removes the old variant-picker buffer.
 * API verified in https://app.kiwisizing.com/web/js/dist/kiwiSizing/plugin/SizingPlugin.prod.js?v=341
 */
if (typeof PUB_SUB_EVENTS !== 'undefined') {
  let ruffSizingObserver;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    ruffSizingObserver?.disconnect();
    if (!data?.variant || typeof window.loadKiwiSizingChart !== 'function') return;
    const productInfo = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
    if (!productInfo) return;
    const restoreChart = () => {
      const pendingBuffer = Array.from(productInfo.querySelectorAll('variant-selects'))
        .some((picker) => picker.style.display === 'none');
      if (pendingBuffer) return false;
      if (!productInfo.querySelector('.ks-chart-modal-link')) window.loadKiwiSizingChart({});
      return true;
    };
    if (restoreChart()) return;
    ruffSizingObserver = new MutationObserver(() => {
      if (restoreChart()) ruffSizingObserver.disconnect();
    });
    ruffSizingObserver.observe(productInfo, { childList: true, subtree: true });
  });
}

